import styled, {css} from "styled-components"

import {H5} from "@irati/ui/src/Typography"

export const StyledImage = styled.img`
  ${({theme}) => css`
    height: auto;
    margin-right: ${theme.spacing.two};
    width: 80px;
  `}
`

export const StyledH5 = styled(H5)`
  flex-grow: 1;
`
